module.exports = __webpack_public_path__ + "media/images/sp/banner/hokepon_reserve-7ee2ebdbc70014a2b954d918df9647a8.png";